var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainerWallpaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1593_77457)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75781 0C6.92278 0 7.07779 0.0789342 7.17482 0.21235L10.0459 4.16012C10.1826 4.34801 10.1767 4.60408 10.0315 4.7855L7.16045 8.37434C7.0626 8.49666 6.91445 8.56786 6.75781 8.56786C6.60117 8.56786 6.45303 8.49666 6.35518 8.37434L3.48408 4.7855C3.33895 4.60408 3.33307 4.34801 3.46971 4.16012L6.34081 0.21235C6.43784 0.0789342 6.59285 0 6.75781 0ZM4.53512 4.44849L6.75781 7.22684L8.9805 4.44849L6.75781 1.39228L4.53512 4.44849Z",
    fill: "#D0BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2422 0C18.4072 0 18.5622 0.0789342 18.6592 0.21235L21.5303 4.16012C21.6669 4.34801 21.6611 4.60408 21.5159 4.7855L18.6448 8.37434C18.547 8.49666 18.3988 8.56786 18.2422 8.56786C18.0855 8.56786 17.9374 8.49666 17.8396 8.37434L14.9685 4.7855C14.8233 4.60408 14.8174 4.34801 14.9541 4.16012L17.8252 0.21235C17.9222 0.0789342 18.0772 0 18.2422 0ZM16.0195 4.44849L18.2422 7.22684L20.4649 4.44849L18.2422 1.39228L16.0195 4.44849Z",
    fill: "#D0BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75781 7.53687C7.04258 7.53687 7.27344 7.76772 7.27344 8.05249V23.4844C7.27344 23.7692 7.04258 24.0001 6.75781 24.0001C6.47304 24.0001 6.24219 23.7692 6.24219 23.4844V8.05249C6.24219 7.76772 6.47304 7.53687 6.75781 7.53687Z",
    fill: "#D0BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2422 7.53687C18.527 7.53687 18.7578 7.76772 18.7578 8.05249V17.7423C18.7578 18.027 18.527 18.2579 18.2422 18.2579C17.9574 18.2579 17.7266 18.027 17.7266 17.7423V8.05249C17.7266 7.76772 17.9574 7.53687 18.2422 7.53687Z",
    fill: "#D0BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 10.5645C0.5 10.2797 0.730853 10.0488 1.01562 10.0488H12.5C12.7848 10.0488 13.0156 10.2797 13.0156 10.5645C13.0156 10.8492 12.7848 11.0801 12.5 11.0801H1.01562C0.730853 11.0801 0.5 10.8492 0.5 10.5645Z",
    fill: "#D0BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 14.8711C0.5 14.5863 0.730853 14.3555 1.01562 14.3555H12.5C12.7848 14.3555 13.0156 14.5863 13.0156 14.8711C13.0156 15.1559 12.7848 15.3867 12.5 15.3867H1.01562C0.730853 15.3867 0.5 15.1559 0.5 14.8711Z",
    fill: "#D0BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9844 10.5645C11.9844 10.2797 12.2152 10.0488 12.5 10.0488H23.9844C24.2691 10.0488 24.5 10.2797 24.5 10.5645C24.5 10.8492 24.2691 11.0801 23.9844 11.0801H12.5C12.2152 11.0801 11.9844 10.8492 11.9844 10.5645Z",
    fill: "#D0BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9844 14.8711C11.9844 14.5863 12.2152 14.3555 12.5 14.3555H23.9844C24.2691 14.3555 24.5 14.5863 24.5 14.8711C24.5 15.1559 24.2691 15.3867 23.9844 15.3867H12.5C12.2152 15.3867 11.9844 15.1559 11.9844 14.8711Z",
    fill: "#D0BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9844 0.515625C11.9844 0.230853 12.2152 0 12.5 0H23.9843C24.2691 0 24.5 0.230853 24.5 0.515625V18.4681C24.5 18.7529 24.2691 18.9838 23.9843 18.9838C23.6996 18.9838 23.4687 18.7529 23.4687 18.4681V1.03125H13.0156V17.7422C13.0156 18.027 12.7848 18.2578 12.5 18.2578C12.2152 18.2578 11.9844 18.027 11.9844 17.7422V0.515625Z",
    fill: "#6750A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9959 17.2574C20.2637 17.3542 20.4024 17.6497 20.3056 17.9176C20.2438 18.0887 20.21 18.274 20.21 18.4683C20.21 19.368 20.9395 20.0976 21.8392 20.0976C22.739 20.0976 23.4685 19.368 23.4685 18.4683C23.4685 18.1835 23.6994 17.9527 23.9841 17.9527C24.2689 17.9527 24.4998 18.1835 24.4998 18.4683C24.4998 19.9375 23.3085 21.1288 21.8392 21.1288C20.37 21.1288 19.1787 19.9375 19.1787 18.4683C19.1787 18.1535 19.2336 17.8497 19.3357 17.5671C19.4325 17.2993 19.7281 17.1606 19.9959 17.2574Z",
    fill: "#6750A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93047 17.2574C10.1983 17.3542 10.3369 17.6497 10.2402 17.9176C10.1783 18.0887 10.1445 18.274 10.1445 18.4683C10.1445 19.368 10.8741 20.0976 11.7738 20.0976H21.8397C22.1244 20.0976 22.3553 20.3284 22.3553 20.6132C22.3553 20.898 22.1244 21.1288 21.8397 21.1288H11.7738C10.3046 21.1288 9.11328 19.9375 9.11328 18.4683C9.11328 18.1535 9.16818 17.8497 9.2703 17.5671C9.36708 17.2993 9.66265 17.1606 9.93047 17.2574Z",
    fill: "#6750A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23926 17.7422C9.23926 17.4574 9.47011 17.2266 9.75488 17.2266H19.8207C20.1055 17.2266 20.3363 17.4574 20.3363 17.7422C20.3363 18.027 20.1055 18.2578 19.8207 18.2578H9.75488C9.47011 18.2578 9.23926 18.027 9.23926 17.7422Z",
    fill: "#6750A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0.515625C0.5 0.230853 0.730853 0 1.01562 0H12.5C12.7847 0 13.0156 0.230853 13.0156 0.515625V17.7421C13.0156 18.0269 12.7847 18.2577 12.5 18.2577C12.2152 18.2577 11.9843 18.0269 11.9843 17.7421V1.03125H1.53125V22.9687H11.9843V20.613C11.9843 20.3282 12.2152 20.0973 12.5 20.0973C12.7847 20.0973 13.0156 20.3282 13.0156 20.613V23.4843C13.0156 23.7691 12.7847 23.9999 12.5 23.9999H1.01562C0.730853 23.9999 0.5 23.7691 0.5 23.4843V0.515625Z",
    fill: "#6750A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1593_77457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerWallpaper);
export default __webpack_public_path__ + "static/media/containerWallpaper.a46a2c2f297f8e3e41af3093faed2a4f.svg";
export { ForwardRef as ReactComponent };